import { PaginationType } from "src/models/common/PaginationType.model";
import apiSlice from "./ApiSlice";

/**
 * "PAN Form Download Report" — PAN applications whose PAN form has not been
 * generated yet. Read-only: a paginated listing plus an XLSX export of the same
 * rows (the export is built server-side with exceljs and streamed back as a
 * blob, so the browser never has to hold the whole result set).
 */
export const panFormReportApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // LIST (paginated)
    getPanFormPendingReport: builder.query({
      providesTags: ["pan-form-report"],
      query: (body: PaginationType) => ({
        url: "/pan-form/pending-list",
        method: "POST",
        body,
      }),
    }),

    // EXPORT XLSX — same filters, no pagination
    exportPanFormPendingXlsx: builder.mutation({
      query: (body: PaginationType) => ({
        url: "/pan-form/pending-export-xlsx",
        method: "POST",
        body,
        responseHandler: (response: any) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetPanFormPendingReportQuery,
  useExportPanFormPendingXlsxMutation,
} = panFormReportApi;

/**
 * "PAN Vendor Data Report" — the other side of the same coin: applications
 * whose PAN form HAS been generated, plus the XLSX in the vendor's own upload
 * sheet layout (built server-side from the form's stored field values).
 */
export const panVendorDataApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // LIST (paginated)
    getPanFormGeneratedList: builder.query({
      providesTags: ["pan-form-report"],
      query: (body: PaginationType) => ({
        url: "/pan-form/generated-list",
        method: "POST",
        body,
      }),
    }),

    // EXPORT XLSX — vendor sheet, same filters, no pagination
    exportPanVendorDataXlsx: builder.mutation({
      query: (body: PaginationType) => ({
        url: "/pan-form/vendor-export-xlsx",
        method: "POST",
        body,
        responseHandler: (response: any) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetPanFormGeneratedListQuery,
  useExportPanVendorDataXlsxMutation,
} = panVendorDataApi;
